import { styled } from "styletron-react";

const LogoContainer = styled("span", () => ({
  display: "flex",
  justifyContent: "center",
}));

export { LogoContainer };
